// Libraries.
import styled from "styled-components";
import {
  scarpaGray500,
  scarpaGray800,
  scarpaGray400,
  robotoRegular,
  monserratRegular,
} from "@habitech/shared";

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;

  .loading-title {
    font-family: "Montserrat Bold", sans-serif;
    font-size: 22px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 0.5rem;
    color: ${scarpaGray500};
  }

  .loading-subtitle {
    font-family: ${robotoRegular};
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    color: ${scarpaGray400};
  }
`;

export const BodyWrapper = styled.div`
  .first-subtitle {
    font-family: ${robotoRegular};
    font-weight: 400;
    font-size: 12px;
    color: ${scarpaGray500};
  }
  .second-subtitle {
    font-family: ${monserratRegular};
    font-weight: 600;
    font-size: 24px;
    color: ${scarpaGray800};
  }
`;
